// ADD TO TOP
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";

import "swiper/swiper-bundle.min.css";

import React, { useState, useEffect } from "react";
import { Box, Typography, Paper, Grid, Button, Container } from "@mui/material";
// import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
// import DesignServicesIcon from "@mui/icons-material/DesignServices";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import AOS from "aos";
import "aos/dist/aos.css";
import { getImageUrl } from "api/ImageViewer";
import DashboardNavbarCustom from "examples/Navbars/DashboardNavbarCustom";
// import zumiTshirt from "assets/images/logos/home_enduser.jpg";
import DesignToolSection from "components/DesignTool/DesignToolSection";
import FooterCustom from "components/FooterCustom/FooterCustom";
import { getWebsite } from "api/configWebsiteAPI";
// import { useNavigate } from "react-router-dom";
// import hotroImage from "assets/images/hotro.png";
// import banner1 from "assets/images/banner1.jpg";
// import banner2 from "assets/images/banner2.jpg";

function HomePage() {
  const [steps, setSteps] = useState([]);
  const [title, setTitle] = useState("");
  const [logoZumi, setLogoZumi] = useState("");
  // const [id, setId] = useState("");
  const [header, setHeader] = useState(null);
  const [banner, setBanner] = useState(null);
  const [content, setContent] = useState(null);
  const [carousel, setCarousel] = useState(null);
  const [footer, setFooter] = useState(null);
  async function fetchConfig() {
    const data = await getWebsite();
    if (data) {
      try {
        // setId(data.id);
        setHeader(JSON.parse(data.header));
        setBanner(JSON.parse(data.banner));
        setContent(JSON.parse(data.content));
        setCarousel(JSON.parse(data.carousel));
        setFooter(JSON.parse(data.footer));

        if (data?.header) {
          const parsedHeader = JSON.parse(data.header);
          if (parsedHeader?.logo) setLogoZumi(getImageUrl(parsedHeader.logo));
        }
      } catch (err) {
        console.error("Lỗi parse JSON:", err);
      }
    }
  }
  useEffect(() => {
    fetchConfig();
  }, []);
  function resolvePreviewSrc(logo) {
    if (!logo) return "";
    if (typeof logo === "string") {
      return logo.startsWith("data:image") ? logo : getImageUrl(logo);
    }
    if (logo instanceof File) {
      return URL.createObjectURL(logo);
    }
    return "";
  }
  // -----------------------------------------------------------HEADER------------------------------------------------------------------
  useEffect(() => {
    setTitle(banner?.title || "");
    if (banner?.steps && Array.isArray(banner.steps)) {
      const mappedSteps = banner.steps.map((step) => ({
        ...step,
        imageFile: step?.imageFile || null,
        imageUrl: resolvePreviewSrc(step?.imageFile),
      }));
      setSteps(mappedSteps);
    }
  }, [banner]);

  // -----------------------------------------------------------CONTENT------------------------------------------------------------------
  const [buttonInfo, setButtonInfo] = useState();
  const [titleContent, setTitleContent] = useState("");
  const [description, setDescription] = useState("");
  const [preview, setPreview] = useState("");
  const [zaloInfo, setZaloInfo] = useState({ text: "", link: "" });

  useEffect(() => {
    setTitleContent(content?.title);
    setDescription(content?.description);
    setPreview(resolvePreviewSrc(content?.image));
    setZaloInfo(
      content?.zaloInfo ?? {
        text: "",
        link: "",
        image: "",
      }
    );
    setButtonInfo(
      content?.buttonInfo ?? {
        text: "",
        link: "",
      }
    );
  }, [content]);
  // -----------------------------------------------------------CAROUSELS------------------------------------------------------------------
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    if (Array.isArray(carousel)) {
      const bannersWithImageUrl = carousel.map((item) => ({
        ...item,
        image: getImageUrl(item.image),
        id: item.id,
      }));
      setBanners(bannersWithImageUrl);
    }
  }, [carousel]);

  // const navigate = useNavigate();
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  // const handleScrollToDesign = () => {
  //   document.getElementById("easy-design-section")?.scrollIntoView({ behavior: "smooth" });
  // };

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f8f9fa",
      }}
    >
      <DashboardNavbarCustom page="Trang chủ" header={header} />

      {/* Header Section */}
      <Box sx={{ flexGrow: 1 }}>
        {/* Easy Design Section */}
        <Box id="easy-design-section" sx={{ backgroundColor: "#e9ecef", py: 8 }}>
          <Container maxWidth="lg">
            <Typography
              variant="h4"
              fontWeight="bold"
              textAlign="center"
              mb={5}
              sx={{
                fontSize: 54,
              }}
            >
              {title}
            </Typography>
            <Grid container spacing={4} justifyContent="center">
              {steps.map((step, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  key={step.title}
                  data-aos="zoom-in"
                  data-aos-delay={index * 150}
                >
                  <Paper
                    elevation={3}
                    sx={{
                      p: 3,
                      textAlign: "center",
                      borderRadius: 4,
                      transition: "transform 0.3s, box-shadow 0.3s",
                      position: "relative",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: 6,
                      },
                    }}
                  >
                    {step.imageUrl && (
                      <Box
                        component="img"
                        src={step.imageUrl}
                        alt={`step-${index}`}
                        sx={{ width: 60, height: 60, mb: 1 }}
                      />
                    )}
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      color="primary"
                      fontSize="17.5px"
                      mb={1}
                    >
                      {index + 1}. {step.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        textAlign: "left",
                        fontSize: 14,
                      }}
                    >
                      {step.description}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        <DesignToolSection />
      </Box>
      <Box sx={{ backgroundColor: "white", py: 10 }}>
        <Container
          maxWidth={false}
          sx={{
            maxWidth: "1400px !important",
            px: { xs: 2, sm: 4 },
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8} data-aos="fade-right">
              <Typography
                variant="h3"
                fontWeight="bold"
                mb={2}
                sx={{
                  fontSize: 62,
                }}
              >
                {titleContent}
              </Typography>
              <Typography
                variant="body1"
                mb={3}
                sx={{
                  fontSize: 22,
                }}
              >
                {description}
              </Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={8}>
                  <a
                    href={zaloInfo?.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "block" }}
                  >
                    <Box
                      component="img"
                      src={resolvePreviewSrc(zaloInfo.image)}
                      alt="Zalo hỗ trợ"
                      sx={{
                        width: "100%",
                        maxHeight: 100,
                        objectFit: "contain",
                        borderRadius: 2,
                        cursor: "pointer",
                        // boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                        transition: "transform 0.3s",
                        "&:hover": {
                          transform: "scale(1.03)",
                        },
                      }}
                    />
                  </a>
                </Grid>

                <Grid item xs={4}>
                  <a
                    href={buttonInfo?.link}
                    // target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "block" }}
                  >
                    <Box
                      component="img"
                      src={resolvePreviewSrc(buttonInfo?.image)}
                      alt="Nút xem mẫu"
                      sx={{
                        width: "100%",
                        maxHeight: 100,
                        objectFit: "contain",
                        borderRadius: 2,
                        // boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        transition: "transform 0.3s",
                        "&:hover": {
                          transform: "scale(1.03)",
                        },
                      }}
                    />
                  </a>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={4} textAlign="center" data-aos="fade-left">
              <Box
                component="img"
                src={preview}
                alt="Zumi mẫu áo"
                sx={{
                  width: 400,
                  height: 400,
                  maxWidth: "100%",
                  borderRadius: 2,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                  cursor: "pointer",
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "scale(1.03)",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* -----------------------------------------------------------CAROUSEL------------------------------------ */}
      <Box sx={{ py: 0, backgroundColor: "#f8f9fa", px: 0 }}>
        <Box sx={{ width: "100vw", position: "relative", left: "calc(-50vw + 50%)" }}>
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            slidesPerView={1}
            loop={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            style={{ borderRadius: 0, overflow: "hidden" }}
          >
            {Array.isArray(banners) && banners.length > 0 ? (
              banners.map((item) => (
                <SwiperSlide key={item.id}>
                  <Box component="a" href={item.link} sx={{ display: "block", width: "100%" }}>
                    <Box
                      component="img"
                      src={item.image}
                      alt="Banner Zumi"
                      sx={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                        borderRadius: 2,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      }}
                    />
                  </Box>
                </SwiperSlide>
              ))
            ) : (
              <SwiperSlide>
                <Box
                  sx={{
                    width: "100%",
                    height: 200,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 18,
                    color: "#999",
                    backgroundColor: "#f0f0f0",
                    borderRadius: 2,
                  }}
                >
                  Vui lòng thêm slide ảnh
                </Box>
              </SwiperSlide>
            )}
          </Swiper>
        </Box>
      </Box>

      <FooterCustom footer={footer} logo={logoZumi} />

      <Button
        onClick={handleScrollTop}
        variant="contained"
        color="primary"
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20,
          zIndex: 999,
          width: "36px !important",
          height: "36px !important",
          minWidth: "unset",
          minHeight: "unset",
          padding: 0,
          borderRadius: "50%",
          boxShadow: 3,
          "&:hover": {
            backgroundColor: "primary.dark",
          },
        }}
      >
        <KeyboardArrowUpIcon />
      </Button>
    </Box>
  );
}

export default HomePage;
